import { render, staticRenderFns } from "./MyPageCuration.vue?vue&type=template&id=7b639871&scoped=true"
import script from "./MyPageCuration.vue?vue&type=script&lang=js"
export * from "./MyPageCuration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b639871",
  null
  
)

export default component.exports